import { useQuery } from '@tanstack/react-query';
import { ReleaseNote } from './Contracts';

const fetchReleaseNotes = async () => {
  const url = 'https://api.geo.ag.ch/v1/releasenotes/agisviewer';
  const requestApi = new Request(url);
  const response = await fetch(requestApi);
  const result = (await response.json()) as ReleaseNote[];

  return result;
};

const useReleaseNotes = () => {
  return useQuery<ReleaseNote[]>({
    queryKey: ['releaseNotes'],
    queryFn: () => fetchReleaseNotes(),
    gcTime: 3600000,
    staleTime: Infinity,
  });
};

export default useReleaseNotes;
